import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  OnboardingProcessStage,
  OnboardingProcessStageRequiredDocuments,
  OnboardingProcessStageSubmittedDocuments,
} from '@interfaces/a-organizar/onboardingCompanyInformation';
import { StageMetrics } from '@features/dashboard/document-analysis-company/helpers/document-analysis-metrics';
import { AnalysisDocumentRowComponent } from '@features/dashboard/document-analysis-company/components/analysis-document-row/analysis-document-row.component';

export interface StageDocumentSelection {
  document: OnboardingProcessStageSubmittedDocuments;
  requiredDocument: OnboardingProcessStageRequiredDocuments;
}

@Component({
  selector: 'app-analysis-stage-section',
  standalone: true,
  imports: [CommonModule, AnalysisDocumentRowComponent],
  templateUrl: './analysis-stage-section.component.html',
  styleUrls: ['./analysis-stage-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisStageSectionComponent {
  @Input({ required: true }) stage!: OnboardingProcessStage;
  @Input({ required: true }) stageLabel!: string;
  @Input({ required: true }) metrics!: StageMetrics;
  @Input() expanded = false;
  @Input() documentLabels: Record<string, string> = {};
  @Input() submissionTooltips: Record<string, string> = {};
  @Input() analysisTooltips: Record<string, string> = {};
  @Input() statusLabels: { approved: string; rejected: string; pending: string } = {
    approved: '',
    rejected: '',
    pending: '',
  };
  @Input() noDocumentSentLabel = '';
  @Output() toggleStage = new EventEmitter<void>();
  @Output() documentSelected = new EventEmitter<StageDocumentSelection>();

  get hasSubmissions(): boolean {
    return this.metrics.submitted > 0;
  }

  labelFor(requiredDocument: OnboardingProcessStageRequiredDocuments): string {
    return this.documentLabels[requiredDocument.name] ?? requiredDocument.name;
  }
}
